import React from 'react';
import { ReactComponent as SortingIcon } from '@blink/assets/src/icons/sorting.svg';

interface SortableHeaderCellProps {
    onClick: () => void;
    children: React.ReactNode;
    icon?: React.ReactNode;
}

export const SortableHeaderCell: React.FC<SortableHeaderCellProps> = ({
    onClick,
    children,
    icon,
}) => {
    return (
        <div
            onClick={onClick}
            className='relative flex items-center gap-3 bg-fourth px-5 py-4 text-md font-medium w-[200px] hover:after:absolute hover:after:inset-0 hover:after:bg-[rgba(0,0,0,0.04)] cursor-pointer select-none'
        >
            {icon && <span className='relative z-10'>{icon}</span>}{' '}
            <span className='flex-1 relative z-10 overflow-hidden text-black font-inter text-[14px] font-semibold leading-[20px] tracking-[-0.03em] truncate'>
                {children}
            </span>
            <SortingIcon />
        </div>
    );
};
